export default function($) {

  "use strict";

  var setBackgroundImage = function( domElem, imagePlaceholder ) {
    var imageUrl = $(imagePlaceholder).data('background-image-url');

    if (imageUrl) {
      $(domElem).css('background-image', 'url(' + imageUrl + ')');
      $(imagePlaceholder).css('min-height', (Math.round($(window).width() / 16 * 9) - 100 ) + 'px');
    }
  }

  var unsetBackgroundImage = function( domElem, imagePlaceholder ) {
    $(domElem).css('background-image', 'none');
    $(imagePlaceholder).css('min-height', '0');
  }

  setBackgroundImage('body', '#body-background');
  $(window).on('resize', function() {
    setBackgroundImage('body', '#body-background');
  });

// In Brands template only

  if( $('.content').find('#body-mobile-background')[0] ) {
    if (window.matchMedia('(max-width: 960px)').matches) {
      setBackgroundImage( 'body', "#body-mobile-background" );
    }

    $(window).on('resize', function() {
      if (window.matchMedia('(max-width: 960px)').matches) {
        setBackgroundImage( 'body', "#body-mobile-background" );
      } else {
        unsetBackgroundImage( 'body', "#body-mobile-background" );
      }
    });
  }

}
